import authModel from '@/model/auth'
import { CheckStatusEnum } from '@/pages/auth/contants'

const state = {
  authInfo: {},
  authStatus: false
}

const mutations = {
  SET_AUTH_INFO(state, info) {
    state.authInfo = info
  },
  SET_AUTH_STATUS(state, status) {
    state.authStatus = status
  }
}
const actions = {
  async getAuthStatus({ commit, state }, type) {
    try {
      const data = await authModel.getAuthStatusApi({ params: { type }})
      commit('SET_AUTH_STATUS', data.status !== CheckStatusEnum.NO)
      commit('SET_AUTH_INFO', data)
    } catch (e) {
      console.log(e)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
